import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
	name: 'capitalizeFirst'
})
export class CapitalizeFirstPipe implements PipeTransform {
	regexPoint = /[.]/g;

	transform(value: string): string {
		if (value === null) return 'Not assigned';

		if (value.search(this.regexPoint) == -1) {
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		} else {
			let t = value.split(this.regexPoint)
			t.forEach((v, i) => {
				t[i] = v.charAt(0).toUpperCase() + v.slice(1).toLowerCase();
			})
			return t.join('.')
		}


	}
}
